export function wssProtocol() {
    return location.protocol === 'https:' ? 'wss' : 'ws'
}